<template>
    <div class="col-md-12 px-0 py-0">
        <div class="form-group row">
            <div class="col-md-7">
                <div class="form-row align mt-3">
                    <div class="form-group col-md-3">
                        <select class="form-control" v-model="criterio">
                            <option value="name">Nombre</option>
                            <option value="email">Correo</option>
                        </select>
                    </div>
                    <div class="form-group col-md-3">
                        <input
                            type="text"
                            v-model="search"
                            @keyup.enter="getListModel()"
                            class="form-control"
                            placeholder="Texto a buscar"
                        />
                    </div>
                    <button
                        type="button"
                        @click="getListModel()"
                        class="btn btn-primary mb-3"
                    >
                        <em class="fa fa-search"></em> Buscar
                    </button>
                    <button
                        type="button"
                        @click="getListModel(1, true)"
                        class="btn btn-primary mb-3 ml-2"
                    >
                        <em class="fa fa-refresh"></em> Actualizar
                    </button>
                </div>
            </div>
            <div class="col-md-5">
                <div class="form-row align mt-3">
                    <div class="form-group col-md-8">
                        <select class="form-control" v-model="contestId">
                            <option value="0">Seleccionar Concurso</option>
                            <option
                                v-for="item in contestList"
                                :value="item.id"
                                :key="item.id"
                            >
                                {{ item.name }} / v-{{ item.version }}
                            </option>
                        </select>
                    </div>
                    <button
                        type="button"
                        @click="downloadProjects()"
                        class="btn btn-primary mb-3"
                    >
                        <em class="fa fa-excel"></em> Exportar
                    </button>
                </div>
            </div>
        </div>
        <table
            class="table table-bordered table-striped table-sm mt-3"
            style="table-layout: fixed"
        >
            <thead>
                <tr>
                    <th style="width: 10%">Opciones</th>
                    <th style="width: 20%">Nombre</th>
                    <th style="width: 20%">Correo</th>
                    <th style="width: 8%">Block-List</th>
                    <th style="width: 37%">Razón</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="model in arrayModel" :key="model.id">
                    <td>
                        <button
                            v-tooltip.bottom-start="'Emular'"
                            type="button"
                            @click="emulate(model.id)"
                            class="btn btn-success btn-sm"
                        >
                            <em class="fa fa-clone"></em>
                        </button>
                        <button
                            v-tooltip.bottom-start="'Ver Detalle'"
                            type="button"
                            @click="changeView(1, model.id)"
                            class="btn btn-info btn-sm"
                        >
                            <em class="fa fa-eye"></em>
                        </button>
                    </td>
                    <td v-text="model.name"></td>
                    <td v-text="model.email"></td>
                    <td>{{model.get_email === 1 ? "Si" : "No"}}</td>
                    <td>{{model.email_send_block_reason !== '' ? model.email_send_block_reason : "-"}}</td>
                </tr>
            </tbody>
        </table>
        <nav>
            <ul class="pagination">
                <li class="page-item" v-if="pagination.current_page > 1">
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page - 1)"
                        >Ant</a
                    >
                </li>
                <li
                    class="page-item"
                    v-for="page in pagesNumber"
                    :key="page"
                    :class="[page == isActived ? 'active' : '']"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(page)"
                        v-text="page"
                    ></a>
                </li>
                <li
                    class="page-item"
                    v-if="pagination.current_page < pagination.last_page"
                >
                    <a
                        class="page-link"
                        href="#"
                        @click="changePage(pagination.current_page + 1)"
                        >Sig</a
                    >
                </li>
            </ul>
        </nav>
    </div>
</template>

<script>
export default {
    data() {
        return {
            arrayModel: [],
            pagination: {
                total: 0,
                current_page: 0,
                per_page: 0,
                last_page: 0,
                from: 0,
                to: 0,
            },
            offset: 15,
            criterio: "name",
            search: "",
            contestId: "0",
            contestList: [],
        };
    },
    computed: {
        isActived: function () {
            return this.pagination.current_page;
        },
        pagesNumber: function () {
            if (!this.pagination.to) {
                return [];
            }
            let from = this.pagination.current_page - this.offset;
            if (from < 1) {
                from = 1;
            }
            let to = from + this.offset;
            if (to >= this.pagination.last_page) {
                to = this.pagination.last_page;
            }
            let pagesArray = [];
            while (from <= to) {
                pagesArray.push(from);
                from++;
            }
            return pagesArray;
        },
    },
    methods: {
        changePage(page) {
            let me = this;
            me.pagination.current_page = page;
            me.getListModel(page, false);
        },
        getListModel(page = 1, refresh = false) {
            let me = this;
            let criterio = me.criterio;
            let search = me.search;
            if (refresh) {
                (criterio = "name"), (search = "");
            }

            axios
                .get(
                    "/api/users?page=" +
                        page +
                        "&criterio=" +
                        criterio +
                        "&search=" +
                        search
                )
                .then(function (response) {
                    me.arrayModel = response.data.models.data;
                    me.pagination = response.data.pagination;
                })
                .catch(function (error) {});
        },
        showActionError(message) {
            const Toast = this.$swal.mixin({
                toast: true,
                icon: "warning",
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                timerProgressBar: true,
            });

            Toast.fire({
                type: "warning",
                title: message,
            });
        },
        emulate(id) {
            let me = this;
            const authUserId = document.querySelector(
                'meta[name="x-user"]'
            ).content;
            const url = `/api/users/emulate/${id}?key=${authUserId}`;
            axios
                .get(url)
                .then(function (response) {
                    let url = response.data;
                    window.open(url, "_blank");
                })
                .catch(function (error) {
                    me.showActionError(error.response.data.error);
                });
        },
        changeView(page, id, name) {
            this.$emit("change", { page: page, id: id });
        },
        getListContest() {
            let _this = this;
            axios
                .get("/api/contests?paginate=false")
                .then(function (response) {
                    _this.contestList = response.data;
                })
                .catch(function (error) {});
        },
        downloadProjects() {
            if (this.contestId > 0) {
                window.open("/users/export/" + this.contestId);
            }
        },
    },
    mounted() {
        this.getListModel();
        this.getListContest();
    },
};
</script>

<style scoped>
.form-control {
    border-radius: 0.2rem !important;
    height: 37px;
}

select.form-control:not([size]):not([multiple]) {
    height: 37px;
}

.btn {
    height: 37px !important;
}

.align {
    display: flex;
    /* justify-content: center; */
    align-items: center;
}
</style>
